
import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";

export const useWorkspaceChange = (onWorkspaceChange: () => void) => {
  const [searchParams] = useSearchParams();
  const workspace = searchParams.get("workspace");
  const prevWorkspace = useRef<string | null>(workspace);

  useEffect(() => {
    if (prevWorkspace.current === workspace) return;
    prevWorkspace.current = workspace;
    onWorkspaceChange(); // ✅ caller decides what to clean up
  }, [workspace, onWorkspaceChange]);
};